/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import {
    Dialog, Heading, Content, ButtonGroup, Button, Divider,
} from "@adobe/react-spectrum";
import React from "react";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import DialogApiBase from "bundle/preview/react-component/dialogs";

class DialogApi extends DialogApiBase {
    showLegalDialog() {
        const appStore = ServiceRegistry.getService("AppStore");
        appStore.setLegalDialogOpen(true);
        if (appStore.isInLinePreset) {
            setTimeout(() => {
                let top = appStore.heightInView.viewStartH;
                const totalHeight = appStore.documentViewUpdate.scrollHeight;
                if (totalHeight > 5000) {
                    top += Math.floor(20 * ((totalHeight - 5000) / 1000));
                }
                if (top + 400 > totalHeight) {
                    top -= 300;
                }
                document.getElementsByClassName("_0YML2q_spectrum-Modal")[0]
                    .setAttribute("style", `top: ${top}px !important; position: fixed !important;`);
                ServiceRegistry.getService("CommandReceiverService").executeCommand({ command: "HIDE_HUD" });
            }, 200);
        }
        if (appStore.isSizedPreset) {
            ServiceRegistry.getService("HUDService").hideHud().then(() => {});
        }
    }

    showLicenseErrorPopup() {
        const appStore = ServiceRegistry.getService("AppStore");
        const clientDomain = appStore.getConfig().eventOrigin;
        const dialogProps = {
            title: this._getFormattedMessage("dialog.license.title"),
            message: this._getFormattedMessage("dialog.license.message.general", { clientDomain }),
        };
        dialogProps.onConfirm = () => {
            window.open(ServiceRegistry.getService("AppStore").getConfig().sdkDocumentationUrl, "_blank");
            return false;
        };
        dialogProps.confirmLabel = this._getFormattedMessage("learn.more");
        dialogProps.closeLabel = this._getFormattedMessage("Close");
        return (
            <Dialog>
                <Heading>{dialogProps.title}</Heading>
                <Divider />
                <Content>{dialogProps.message}</Content>
                <ButtonGroup>
                    <Button onPress={ dialogProps.onConfirm } UNSAFE_style={ { cursor: "pointer" } }>
                        {dialogProps.confirmLabel}
                    </Button>
                    <Button
                        onPress={ () => {
                            const store = ServiceRegistry.getService("AppStore");
                            store.setLicenseErrorPopupDismissed();
                        } }
                        UNSAFE_style={ { cursor: "pointer" } }
                    >
                        {dialogProps.closeLabel}
                    </Button>
                </ButtonGroup>
            </Dialog>
        );
    }
}

export default DialogApi;
